import React from 'react';
import cn from 'classnames';
import { useTheme } from '../../../../theme';
import Fare from './Fare/Fare';
import SlickSlider from '../../../../SlickSlider';
const HeaderSlider = ({ compareTableHeader, settings, isFullFareConditions, onSetCurrentSlide, selectedFare, selectedFareName, contentTableRef, topSliderRef }) => {
    var _a;
    const { FaresSlider: sliderCss, Header: css } = useTheme('CompareFares');
    let isImagesPresentInResponse;
    const topSliderSettings = Object.assign(Object.assign({}, settings), { arrows: true, afterChange: currentSlide => {
            onSetCurrentSlide(currentSlide);
        } });
    if (compareTableHeader) {
        isImagesPresentInResponse = !!((_a = compareTableHeader === null || compareTableHeader === void 0 ? void 0 : compareTableHeader[0]) === null || _a === void 0 ? void 0 : _a.image);
    }
    React.useEffect(() => {
        if (compareTableHeader) {
            const index = compareTableHeader.findIndex(group => (group === null || group === void 0 ? void 0 : group.title) === selectedFareName);
            onSetCurrentSlide(index > 0 ? index : 0);
        }
    }, [compareTableHeader, selectedFareName]);
    return (React.createElement("div", { className: css.row },
        React.createElement("div", { className: cn(sliderCss.title, css.headerTitle) },
            React.createElement("div", { className: css.arrows })),
        React.createElement("div", { className: cn(css.row, sliderCss.slider, {
                [css.slider_fullConditions]: isFullFareConditions,
                [css.slider_withoutImages]: !isImagesPresentInResponse
            }) },
            React.createElement("div", { className: cn(sliderCss.slider) },
                React.createElement(SlickSlider, Object.assign({}, topSliderSettings, { ref: topSliderRef }), compareTableHeader === null || compareTableHeader === void 0 ? void 0 : compareTableHeader.map((fare, index) => (React.createElement(Fare, { key: fare.title, isFullFareConditions: isFullFareConditions, selectedFare: selectedFare, fare: fare, fareIndex: index, contentTableRef: contentTableRef }))))))));
};
export default HeaderSlider;
